import { Howler } from "howler";

let isMuffled = false;

let muffleFilter: BiquadFilterNode | null = null;

function getCtx() {
  const ctx = Howler.ctx;

  if (!ctx) {
    throw new Error("Howler AudioContext not initialized yet!");
  }

  return ctx;
}

function getFilter() {
  const ctx = getCtx();

  if (!muffleFilter) {
    muffleFilter = ctx.createBiquadFilter();
    muffleFilter.type = "lowpass";
    muffleFilter.frequency.value = 700;
  }

  return muffleFilter;
}

export function enableMuffle() {
  if (isMuffled) return;

  const ctx = getCtx();
  const masterGain = Howler.masterGain as GainNode;

  const filter = getFilter();

  masterGain.disconnect();
  masterGain.connect(filter);
  filter.connect(ctx.destination);

  isMuffled = true;
}

export function disableMuffle() {
  if (!isMuffled) return;

  const ctx = getCtx();
  const masterGain = Howler.masterGain as GainNode;

  const filter = getFilter();

  filter.disconnect();
  masterGain.disconnect();

  masterGain.connect(ctx.destination);

  isMuffled = false;
}
